<mat-card>
  <div class="header">提现到支付宝</div>

  <div class="content">
    <mat-form-field appearance="outline">
      <mat-label>账号</mat-label>
      <input
        matInput
        placeholder="请填写支付宝收款账号，一般是手机号"
        [(ngModel)]="loginID"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>姓名</mat-label>
      <input matInput placeholder="收款支付宝绑定的姓名" [(ngModel)]="name" />
    </mat-form-field>

    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>金额</mat-label>
      <input
        matInput
        placeholder="提现金额"
        [(ngModel)]="amount"
        type="number"
        step="0.01"
        [min]="0.01"
        [max]="affiliate?.available_commission"
      />
      <mat-icon matIconPrefix inline>currency_yuan</mat-icon>
    </mat-form-field>

    <span
      >可提现金额：
      <app-price [price]="affiliate?.available_commission"></app-price
    ></span>

    <button mat-flat-button class="confirm" (click)="onOk()">
      <div class="container">
        <svg
          viewBox="0 0 1024 1024"
          width="1.4rem"
          height="1.4rem"
          class="mr-5px"
          data-v-b9647d40=""
        >
          <path
            fill="currentColor"
            d="M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6c-61 53-24.5 150 99 150c71.8 0 143.5-45.7 199.8-119c-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5c-75.6-29.8-213.6-85-286.8-120.1c-69.9 85.7-160.1 137.8-253.7 137.8c-158.4 0-212.1-138.1-137.2-229c16.3-19.8 44.2-38.7 87.3-49.4c67.5-16.5 175 10.3 275.7 43.4c18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8c47.5 17.1 90.1 33.3 121.8 43.9z"
          ></path>
        </svg>
        <span>支付宝提现</span>
      </div>
    </button>
    <p class="hint">需要使用其他方式提现的用户请联系客服处理</p>
  </div>
  <app-global-loading *ngIf="loading"></app-global-loading>

  <!-- <h2>提现记录</h2> -->
  <!-- <div class="header">提现记录</div> -->
  <div class="table">
    <table mat-table [dataSource]="withdrawals">
      <!-- Position Column -->
      <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef>提现时间</th>
        <td mat-cell *matCellDef="let element">
          <app-datetime [text]="element.created_time"></app-datetime>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="method">
        <th mat-header-cell *matHeaderCellDef>提现方式</th>
        <td mat-cell *matCellDef="let element">{{ element.payment_method }}</td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="account">
        <th mat-header-cell *matHeaderCellDef>账号</th>
        <td mat-cell *matCellDef="let element">
          {{ element.payment_account }}
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>金额</th>
        <td mat-cell *matCellDef="let element">
          ￥{{ element.amount | number }}
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td
          class="mat-cell"
          [attr.colspan]="displayedColumns.length"
          style="text-align: center"
        >
          <svg viewBox="0 0 160 160" style="width: 200px; height: 200px">
            <defs>
              <linearGradient x1="50%" x2="50%" y2="100%" id="van-empty-1-5">
                <stop stop-color="#F2F3F5" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                x1="95%"
                y1="48%"
                x2="5.5%"
                y2="51%"
                id="van-empty-1-6"
              >
                <stop stop-color="#EAEDF1" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
              <linearGradient y1="45%" x2="100%" y2="54%" id="van-empty-1-7">
                <stop stop-color="#EAEDF1" offset="0%"></stop>
                <stop stop-color="#DCDEE0" offset="100%"></stop>
              </linearGradient>
            </defs>
            <defs>
              <linearGradient id="van-empty-1-a" x1="64%" y1="100%" x2="64%">
                <stop stop-color="#FFF" offset="0%" stop-opacity="0.5"></stop>
                <stop stop-color="#F2F3F5" offset="100%"></stop>
              </linearGradient>
            </defs>
            <g opacity=".8">
              <path
                d="M36 131V53H16v20H2v58h34z"
                fill="url(#van-empty-1-a)"
              ></path>
              <path
                d="M123 15h22v14h9v77h-31V15z"
                fill="url(#van-empty-1-a)"
              ></path>
            </g>
            <defs>
              <linearGradient
                id="van-empty-1-b"
                x1="64%"
                y1="97%"
                x2="64%"
                y2="0%"
              >
                <stop
                  stop-color="#F2F3F5"
                  offset="0%"
                  stop-opacity="0.3"
                ></stop>
                <stop stop-color="#F2F3F5" offset="100%"></stop>
              </linearGradient>
            </defs>
            <g opacity=".8">
              <path
                d="M87 6c3 0 7 3 8 6a8 8 0 1 1-1 16H80a7 7 0 0 1-8-6c0-4 3-7 6-7 0-5 4-9 9-9Z"
                fill="url(#van-empty-1-b)"
              ></path>
              <path
                d="M19 23c2 0 3 1 4 3 2 0 4 2 4 4a4 4 0 0 1-4 3v1h-7v-1l-1 1c-2 0-3-2-3-4 0-1 1-3 3-3 0-2 2-4 4-4Z"
                fill="url(#van-empty-1-b)"
              ></path>
            </g>
            <g transform="translate(36 50)" fill="none">
              <g transform="translate(8)">
                <rect
                  fill="#EBEDF0"
                  opacity=".6"
                  x="38"
                  y="13"
                  width="36"
                  height="53"
                  rx="2"
                ></rect>
                <rect
                  fill="url(#van-empty-1-5)"
                  width="64"
                  height="66"
                  rx="2"
                ></rect>
                <rect
                  fill="#FFF"
                  x="6"
                  y="6"
                  width="52"
                  height="55"
                  rx="1"
                ></rect>
                <g transform="translate(15 17)" fill="url(#van-empty-1-6)">
                  <rect width="34" height="6" rx="1"></rect>
                  <path d="M0 14h34v6H0z"></path>
                  <rect y="28" width="34" height="6" rx="1"></rect>
                </g>
              </g>
              <rect
                fill="url(#van-empty-1-7)"
                y="61"
                width="88"
                height="28"
                rx="1"
              ></rect>
              <rect
                fill="#F7F8FA"
                x="29"
                y="72"
                width="30"
                height="6"
                rx="1"
              ></rect>
            </g>
          </svg>
          <div>暂无数据</div>
        </td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-card>
